import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Tooltip,
    Badge,
    Typography
} from '@mui/material';
import { Group as GroupIcon } from '@mui/icons-material';
import { TeamList } from '../../helpers/ai/shared/TeamManagment/TeamList'; // путь может отличаться

const TeamSummary = ({ teamMembers, currentUserRole, theme }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleOpen = () => setDialogOpen(true);
    const handleClose = () => setDialogOpen(false);

    const memberCount = teamMembers?.length || 0;

    return (
        <>
            <Tooltip title={`Команда (${memberCount} участников)`}>
                <IconButton size="small" onClick={handleOpen}>
                    <Badge badgeContent={memberCount} color="primary">
                        <GroupIcon fontSize="small" className="view-result-icon" />
                    </Badge>
                </IconButton>
            </Tooltip>

            <Dialog open={dialogOpen} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Участники команды
                </DialogTitle>
                <DialogContent dividers>
                    {memberCount === 0 ? (
                        <Typography align="center">Нет данных о команде</Typography>
                    ) : (
                        <TeamList
                                team={teamMembers}
                                currentUserAccess={{ canManageTeam: false, role: currentUserRole }}
                                onEditUserAssess={() => { }}
                                handleDeleteUserAccesses={() => { }}
                                onUserTaskAccessDeleted={() => { }}
                                onTransferCreatorRole={() => { }}
                                onSendNotifications={() => { }}
                                theme={theme}
                                isReadonly={true}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} className="dt1520-button active-dt1520-button view-button default-button">
                        Закрыть
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TeamSummary;